import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { func, shape } from "prop-types";

import { RecoveryPasswordStep4 } from "@ui-kit/components/index.es";
import withExchangeToken from "pages/_components/withExchangeToken";
import { actions as layoutActions } from "reducers/layout";
import * as i18n from "util/i18n";

function RecoveryPasswordStep4V3({ dispatch, history }) {
    useEffect(() => {
        dispatch(layoutActions.setScopes(["recoveryPassword"]));
        return () => {
            dispatch(layoutActions.setScopes([]));
        };
    }, [dispatch]);

    const handleGoToLogin = useCallback(() => {
        history.push("/v3/login");
    }, [history]);

    const getText = useCallback((id) => i18n.get(id), []);

    return <RecoveryPasswordStep4 getText={getText} handleGoToLogin={handleGoToLogin} />;
}

RecoveryPasswordStep4V3.propTypes = {
    dispatch: func.isRequired,
    history: shape({ push: func }).isRequired,
};

export default compose(connect(), withExchangeToken)(RecoveryPasswordStep4V3);
